
import { format } from 'date-fns'
import VueHtml2pdf from 'vue-html2pdf'
import firebase from 'firebase/compat/app'
import { mapState, mapGetters } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import camelCase from 'lodash/camelCase'
import upperFirst from 'lodash/upperFirst'

import { saveProcedureRating } from '@/services/Procedure'

import PostIdMixin from '@/mixins/PostIdMixin'

export default {
  name: 'Ficha',
  components: {
    VueHtml2pdf,
  },
  mixins: [PostIdMixin],
  scrollToTop: true,
  data() {
    return {
      loading: true,
      ratingData: {},
      itemsBreadcrumbs: [
        {
          text: this.$t('home'),
          disabled: false,
          href: '/',
          fontWeight: 'bold',
          color: 'black',
        },
        {
          text: this.$t('digital-services'),
          disabled: false,
          href: '/digital-services',
          fontWeight: 'bold',
          color: 'black',
        },
        {
          text: this.$t('post.ficha'),
          disabled: true,
          href: '',
          fontWeight: 'normal',
          color: 'black',
        },
      ],
      cleanedAnswersOperator: {},
      procedurePlaylists: [],
      allContent: {},
      rutaParaFicha: '',
      fichaOnline: true,
      exteriorProcess: false,
      onlyAppointments: false,
      acceptRequests: true,
      headerCards: [],
      subheaderCards: [],
      contents: [],
      files: [],
    }
  },
  async fetch() {
    this.loading = true
    await this.getPostData()
    await this.checkAnswersInOtherSections()
    await this.checkForPlaylists()
    this.allContent = await this.setAllContent()
    this.rutaParaFicha = await this.setRutaParaFicha()
    this.fichaOnline = await this.setFichaOnline()
    this.exteriorProcess = await this.setExteriorProcess()
    this.onlyAppointments = await this.setOnlyAppointments()
    this.acceptRequests = await this.setAcceptRequests()
    this.headerCards = await this.setHeaderCards()
    this.subheaderCards = await this.setSubheaderCards()
    this.contents = await this.setContents()
    this.files = await this.setFiles()
    // this.$store.dispatch('loaderFull/close')
    this.loading = false
  },
  computed: {
    ...mapState({ brand: (state) => state.brand.brand }),

    cssVars() {
      return { '--primary-color': this.brand.primary_color }
    },
    path() {
      return this.$route.path
    },
    previousPath() {
      const lastIndex = this.$route.path.lastIndexOf('/')
      const previousPath = `${this.$route.path.slice(0, lastIndex + 1)}`
      return previousPath
    },
    ...mapGetters({
      user: 'users/user',
      loggedIn: 'loggedIn',
    }),
  },
  // mounted() {
  //   this.$store.dispatch('loaderFull/open')
  // },
  methods: {
    async checkForPlaylists() {
      const querySnapshot = await this.$fire.firestore
        .collection('modules/ventanillaDigital/playlist')
        .where('activeList', '==', true)
        .where('proceduresIds', 'array-contains', this.post.id)
        .get()

      if (!querySnapshot.empty) {
        this.procedurePlaylists.push(
          ...querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
        )
      }
    },
    formatTitleFile(title) {
      return upperFirst(camelCase(title))
    },
    checkAnswersInOtherSections() {
      // Obtenemos las secciones de las preguntas creadas en el submódulo para el operador
      const answersOperator = cloneDeep(this.post.answersOperator)
      // Obtener secciones únicas
      // Array.from(new Set(...)) simplifica la obtención de secciones únicas sin necesidad de un filtro
      const sections = Array.from(
        new Set(
          this.post.answersOperatorConfig.map((question) => question.section)
        )
      )
      // Crear secciones y asignar preguntas como null
      sections.forEach((section) => {
        if (!answersOperator[section]) {
          answersOperator[section] = { schema: {} }
          this.post.answersOperatorConfig
            .filter((question) => question.section === section)
            .forEach((question) => {
              answersOperator[section].schema[question.id] = null
            })
        }
      })
      // Buscar respuestas anteriores en secciones
      sections.forEach((section) => {
        Object.keys(answersOperator[section].schema).forEach((questionId) => {
          if (!answersOperator[section].schema[questionId]) {
            this.searchInModel(questionId, answersOperator, section)
          }
        })
      })
      this.cleanedAnswersOperator = answersOperator
    },
    searchInModel(questionId, model, parentKey) {
      Object.keys(model).forEach((key) => {
        Object.keys(model[key].schema).forEach((modelId) => {
          // Si la respuesta no existe en otra sección, o esta indefinida, se deja como nula
          if (
            parentKey !== key &&
            questionId === modelId &&
            model[key].schema[modelId] !== undefined
          ) {
            model[parentKey].schema[questionId] = model[key].schema[modelId]
          }
        })
      })
    },
    getRatingData(data) {
      this.$store.dispatch('loaderFull/open')
      this.ratingData = data

      if (this.loggedIn && this.user?.uid) {
        this.ratingData.userUid = this.user.uid
      } else {
        this.ratingData.userUid = 'anonymous'
      }
      try {
        saveProcedureRating(this.$fire, this.path, this.ratingData)
        this.$store.dispatch('notifications/open', {
          color: 'success',
          text: 'Se ha guardado tu calificación del trámite',
        })

        this.$store.dispatch('loaderFull/close')
      } catch {
        this.$store.dispatch('notifications/open', {
          color: 'error',
          text: 'No se pudo guardar el rating',
        })

        this.$store.dispatch('loaderFull/close')
      }
    },
    async generateReport() {
      await this.$refs.html2Pdf.generatePdf()
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      const self = this
      this.$store.dispatch('loaderFull/open')

      try {
        await html2pdf()
          .set(options)
          .from(pdfContent)
          .toPdf()
          .get('pdf')
          .then((pdf) => {
            const totalPages = pdf.internal.getNumberOfPages()
            for (let i = 1; i <= totalPages; i++) {
              pdf.setPage(i)
              pdf.setFontSize(10)
              pdf.setTextColor(150)
              pdf.text(
                self.$t('page') +
                  ' ' +
                  i +
                  ' ' +
                  this.$t('of') +
                  ' ' +
                  +totalPages,
                pdf.internal.pageSize.getWidth() * 0.8,
                pdf.internal.pageSize.getHeight() - 12
              )
              if (i === totalPages) {
                const fecha = self.formatDate(
                  firebase.firestore.Timestamp.now()
                )
                pdf.text(
                  `Fecha de descarga: ${fecha}`,
                  15,
                  pdf.internal.pageSize.getHeight() - 12
                )
                // const img = this.$store.getters['brand/logo']
                // pdf.addImage(img, 'PNG', 8, 12, 35, 15)
              }
              /*  pdf.text(
              'Gobierno de Monterrey',
              15,
              pdf.internal.pageSize.getHeight() - 12
            ) */
              // const img = this.$store.getters['brand/logo']
              // pdf.addImage(img, 'PNG', 8, 12, 35, 15)
            }
          })
          .save()
        self.$store.dispatch('notifications/open', {
          color: 'success',
          text: 'Se ha generado el PDF con éxito',
        })
      } catch (error) {
        // eslint-disable-next-line no-console
        self.$store.dispatch('notifications/open', {
          color: 'error',
          text: 'Ocurrió un error, intenta más tarde.',
        })
      }
      this.$store.dispatch('loaderFull/close')
    },
    // Función que le da formato a una fecha
    formatDate(val) {
      if (val != null) {
        const isValidDate = Date.parse(val)

        if (!isNaN(isValidDate)) {
          val = new Date(val)
          return (
            format(new Date(val), 'dd/MM/yyyy') +
            '<br>' +
            format(new Date(val), 'HH:mm:ss') +
            ' hrs'
          )
        } else {
          return (
            format(
              new Date((val.seconds || val._seconds) * 1000),
              'dd/MM/yyyy HH:mm:ss'
            ) + ' hrs'
          )
        }
      }
    },
    setRutaParaFicha() {
      let route = ''
      if (
        this.post.availableOnline === undefined ||
        (this.post.availableOnline &&
          !this.post.exteriorProcess &&
          !this.post.config.setOnlyAppointments)
      ) {
        // route = `${this.$route.path}/steps?t=${this.$route.query.t}`
        route = `${this.$route.path}/steps`
      } else if (
        this.post.availableOnline === true &&
        this.post.exteriorProcess === true
      )
        route = `${this.post.exteriorURL}`
      else if (
        this.post.availableOnline === false &&
        this.post.config.setOnlyAppointments === false
      )
        route = '/'
      else if (
        this.post.availableOnline === false &&
        this.post.exteriorProcess === false &&
        this.post.config.setOnlyAppointments === true
      )
        route = `${this.$route.path}/appointment`
      // else route = `${this.$route.path}/steps?t=${this.$route.query.t}`
      else route = `${this.$route.path}/steps`
      // eslint-disable-next-line prettier/prettier
      route = route.replace('//steps', '/steps')

      return route
    },
    setFichaOnline() {
      let fichaOnline = true
      if (
        this.post.availableOnline === undefined ||
        (this.post.availableOnline && !this.post.exteriorProcess) ||
        (this.post.availableOnline && this.post.exteriorProcess)
      ) {
        fichaOnline = true
      } else if (this.post.availableOnline === false) fichaOnline = false
      else fichaOnline = true

      return fichaOnline
    },
    setExteriorProcess() {
      return this.post.exteriorProcess === true // Retorna true solo si es true
    },
    setOnlyAppointments() {
      return this.post.config.setOnlyAppointments === true // Retorna true solo si es true
    },
    setAcceptRequests() {
      let acceptRequests = true
      if (
        this.post.config.acceptRequests === undefined ||
        this.post.config.acceptRequests === null ||
        this.post.config.acceptRequests
      )
        acceptRequests = true
      else if (!this.post.config.acceptRequests) acceptRequests = false
      return acceptRequests
    },
    setAllContent() {
      // Todos los campos de la ficha aparecen para este caso
      const allContent = this.post.answersOperatorConfig.filter(
        (answer) => answer.kind !== 'file'
      )
      const allContentArray = allContent.map((answer) => {
        let description =
          this.cleanedAnswersOperator[answer.section] &&
          this.cleanedAnswersOperator[answer.section].schema &&
          this.cleanedAnswersOperator[answer.section].schema[answer.id]
            ? this.cleanedAnswersOperator[answer.section].schema[answer.id]
            : ''

        if (
          typeof description === 'object' &&
          Object.keys(description).includes('name')
        ) {
          description = description.name
        }
        if (Array.isArray(description)) {
          description =
            '<ul>' +
            description
              .map((value) => {
                return typeof value === 'object'
                  ? `<li>${value.name}</li>`
                  : typeof value !== 'undefined'
                  ? `<li>${value}</li>`
                  : ''
              })
              .join('') +
            '</ul>'
        }

        const dataToReturn = {
          question: answer.label,
          answer: description,
          icon: answer.icon,
          section: answer.section,
          sectionTitle: answer.sectionTitle,
          sectionRichTitle: answer.sectionRichText || answer.richTextLabel,
          id: answer.id,
        }
        return dataToReturn
      })
      const allContentMap = allContentArray.reduce((acc, cur) => {
        if (!acc[cur.section]) {
          acc[cur.section] = []
        }
        acc[cur.section].push(cur)
        return acc
      }, {})

      return allContentMap
    },
    setHeaderCards() {
      const headerCardsQuestions = this.post.answersOperatorConfig.filter(
        (answer) =>
          answer.showOnFile === true && answer.positionOnFile === 'header_cards'
      )
      const headerCardsConfig = headerCardsQuestions.sort(
        (a, b) => a.indexInFile - b.indexInFile
      )
      return headerCardsConfig.map((answer) => {
        let description =
          this.cleanedAnswersOperator[answer.section] &&
          this.cleanedAnswersOperator[answer.section].schema &&
          this.cleanedAnswersOperator[answer.section].schema[answer.id]
            ? this.cleanedAnswersOperator[answer.section].schema[answer.id]
            : ''
        if (
          typeof description === 'object' &&
          Object.keys(description).includes('name')
        ) {
          description = description.name
        }
        if (Array.isArray(description)) {
          description =
            '<ul>' +
            description
              .map((value) => {
                return typeof value === 'object'
                  ? `<li>${value.name}</li>`
                  : typeof value !== 'undefined'
                  ? `<li>${value}</li>`
                  : ''
              })
              .join('') +
            '</ul>'
        }

        return {
          title: answer.label,
          description,
          icon: answer.icon,
        }
      })
    },
    setSubheaderCards() {
      const subheaderQuestions = this.post.answersOperatorConfig.filter(
        (answer) =>
          answer.showOnFile === true &&
          answer.positionOnFile === 'subheader_cards'
      )
      const subheaderCardsConfig = subheaderQuestions.sort(
        (a, b) => a.indexInFile - b.indexInFile
      )
      return subheaderCardsConfig.map((answer) => {
        let description =
          this.cleanedAnswersOperator[answer.section] &&
          this.cleanedAnswersOperator[answer.section].schema &&
          this.cleanedAnswersOperator[answer.section].schema[answer.id]
            ? this.cleanedAnswersOperator[answer.section].schema[answer.id]
            : ''
        if (
          typeof description === 'object' &&
          Object.keys(description).includes('name')
        ) {
          description = description.name
        }
        if (Array.isArray(description)) {
          description =
            '<ul>' +
            description
              .map((value) => {
                return typeof value === 'object'
                  ? `<li>${value.name}</li>`
                  : typeof value !== 'undefined'
                  ? `<li>${value}</li>`
                  : ''
              })
              .join('') +
            '</ul>'
        }
        return {
          title: answer.label,
          description,
          icon: answer.icon,
        }
      })
    },
    setContents() {
      const contentQuestions = this.post.answersOperatorConfig.filter(
        (answer) =>
          answer.showOnFile === true && answer.positionOnFile === 'contents'
      )
      const contentsConfig = contentQuestions.sort(
        (a, b) => a.indexInFile - b.indexInFile
      )
      return contentsConfig.map((answer) => {
        let text =
          this.cleanedAnswersOperator[answer.section] &&
          this.cleanedAnswersOperator[answer.section].schema &&
          this.cleanedAnswersOperator[answer.section].schema[answer.id]
            ? this.cleanedAnswersOperator[answer.section].schema[answer.id]
            : ''
        if (typeof text === 'object' && Object.keys(text).includes('name')) {
          text = text.name
        }
        if (Array.isArray(text)) {
          text =
            '<ul>' +
            text
              .map((value) => {
                return typeof value === 'object'
                  ? `<li>${value.name}</li>`
                  : typeof value !== 'undefined'
                  ? `<li>${value}</li>`
                  : ''
              })
              .join('') +
            '</ul>'
        }
        if (!text) {
          text = ''
        }
        return {
          title: answer.label,
          text,
        }
      })
    },
    setFiles() {
      const fileConfig = this.post.answersOperatorConfig.filter(
        (answer) => answer.kind === 'file'
      )
      return fileConfig.map((answer) => {
        const link =
          this.cleanedAnswersOperator &&
          this.cleanedAnswersOperator[answer.section] &&
          this.cleanedAnswersOperator[answer.section].schema &&
          this.cleanedAnswersOperator[answer.section].schema[answer.id]
            ? this.cleanedAnswersOperator[answer.section].schema[answer.id]
            : ''

        return {
          title: answer.label,
          link,
        }
      })
    },
  },
}
